import OlMap from "../components/OlMap";
import { useLocation } from "react-router-dom";

export default function Map() {
    const location = useLocation();
    const lng = location.state?location.state.lng:7.8898;
    const lat = location.state?location.state.lat:51.7597;
    
    return (
        <div>
            <OlMap latitude={lat} longitude={lng}/>
        </div>
    )
}